import * as selectors from './selectors'
import * as formatters from './formatters'
import * as actions from './actions'

import slice from './reducer'
import saga from './saga'

const reducer = slice.reducer

export { selectors, formatters, actions, reducer, saga }
